// extracted by mini-css-extract-plugin
export default {"fadeInUp":"Animations_fadeInUp__VxUFK"};